import { useTranslation } from 'react-i18next';
import { Button, Dialog, Flex, HeaderItalic, Text } from '@/components/common';

interface PendingChangesDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onKeepEditing: () => void;
  onDiscard: () => void;
  onSaveAndExit: () => void;
}

export function PendingChangesDialog({
  open,
  onOpenChange,
  onKeepEditing,
  onDiscard,
  onSaveAndExit,
}: PendingChangesDialogProps) {
  const { t } = useTranslation('profile');

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Content size="2" maxWidth="320px" aria-describedby={undefined}>
        <Dialog.Title className="sr-only">{t('edit.leaveDialog.title')}</Dialog.Title>
        <Flex direction="column" gap="4">
          <HeaderItalic size="4">{t('edit.leaveDialog.title')}</HeaderItalic>
          <Text size="2" color="gray">
            {t('edit.leaveDialog.message')}
          </Text>
          <Flex direction="column" gap="2">
            <Button
              type="button"
              color="gray"
              highContrast
              size="lg"
              fullWidth
              onClick={onKeepEditing}
            >
              {t('edit.leaveDialog.keepEditing')}
            </Button>
            <Button
              type="button"
              variant="outline"
              color="gray"
              size="lg"
              fullWidth
              onClick={onDiscard}
            >
              {t('edit.leaveDialog.discard')}
            </Button>
            <Button type="button" size="lg" fullWidth onClick={onSaveAndExit}>
              {t('edit.leaveDialog.saveAndExit')}
            </Button>
          </Flex>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
}
